<template>
  <MiniToast
    ref="toastRef"
    class="app-toast"
    :variant="variant"
    :duration="4000"
    @hide="globalStore.clearToast"
  >
    <ErrorIcon
      v-if="variant === TOAST_VARIANT.ERROR"
      class="app-toast__icone app-toast__icone--error"
    />
    <CheckIcon v-else class="app-toast__icone" />
    {{ message }}
  </MiniToast>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import MiniToast from '@/components/MiniToast.vue';
import useGlobalStore, { TOAST_VARIANT } from '@/stores/global';
import CheckIcon from '~icons/ic/baseline-check';
import ErrorIcon from '~icons/ic/outline-error-outline';

const globalStore = useGlobalStore();
const toastRef = ref<{ show: () => void } | null>(null);
const message = ref('');
const variant = ref(TOAST_VARIANT.ERROR);

watch(
  () => globalStore.toast,
  async toast => {
    if (!toast) return;
    message.value = toast.message;
    variant.value = toast.variant;
    await nextTick();
    toastRef.value?.show();
  }
);
</script>

<style lang="scss" scoped>
@use "@/assets/styles/vars" as *;

// MiniToast esconde-se com display:none (.hide), o que impede animação.
// Sobrescrevemos para manter o elemento em fluxo e animar entrada/saída.
.app-toast.mini-toast {
  position: fixed;
  top: $space-xs;
  left: 50%;
  z-index: 1200;
  display: flex !important;
  align-items: center;
  gap: 10px;
  max-width: calc(100vw - #{$space-md});
  padding: 12px 20px;
  border-radius: 10px;
  background: #1e1e22;
  border-bottom: 3px solid #25d366;
  box-shadow: var(--acerto-box-shadow);
  color: #fff;
  font-size: .875rem;
  font-weight: 700;
  opacity: 0;
  pointer-events: none;
  transform: translateX(-50%) translateY(-140%);
  transition: transform .28s ease, opacity .28s ease;
}

.app-toast.mini-toast:not(.hide) {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(-50%) translateY(0);
}

.app-toast.mini-toast.error {
  border-bottom-color: var(--acerto-colors-red-500);
}

.app-toast__icone {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  color: #25d366;

  &--error {
    color: var(--acerto-colors-red-500);
  }
}
</style>
